export default __webpack_public_path__ + "static/media/DemoIconSVG.c2d16b04.svg";